<template>
  <div class="loginContainer">
    <div style="margin-left: 40%; font-size: 25px;">
      <H1>砍树挂号管家</H1>
    </div>
      <div>
        <div>
            <el-form :inline="true" label-position="right" size="default">
              <el-row :gutter="24">
                <el-col :span="6" class="panda-search-row-input-group" style="width: 250px;">
                  <el-form-item label="" style="width: 100%;">
                    <el-input style="width: 100%;" v-model="searchValue.loginId" class="panda-search-item" placeholder="账号" clearable/>
                  </el-form-item>
                </el-col>
                <el-col :span="10" type="flex" class="panda-search-row-button-group" justify="end">
                  <el-form-item>
                    <el-button type="primary" @click="ZhOne">查 询</el-button>
                    <el-button type="primary" @click="ZhInfo">查询全部账号</el-button>
                    <el-button type="primary" @click="addZh">添加账号</el-button>
                    <el-button type="primary" @click="test">重 置</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div>
            <el-table max-height="482" v-loading="loading"
                element-loading-text="正在加载..."
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="items" stripe  border size="default" style="width: 80%">
              <el-table-column align="center" label="序号" width="80" fixed>
                <template #default="scope">
                  {{(scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="username" label="账号" width="230" />
              <el-table-column align="center" prop="serverName" label="区服" width="150"/>
              <el-table-column align="center" prop="nickName" label="角色名" width="160" />
              <el-table-column align="center" prop="enabled" label="启用状态" width="130">
                <template #default="scope">
                  <el-tag v-if="scope.row.enabled" type="success">已开启</el-tag>
                  <el-tag v-else type="danger">未开启</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="startDate" label="生效时间" width="180"/>
              <el-table-column align="center" prop="startDate" label="剩余天数" width="100" :formatter="shengyutianshu"/>
              <el-table-column align="center" fixed="right" label="操作" width="305">
                <template #default="scope">
                    <el-button link type="primary" size="mini" @click="zhBJ(scope.row)">账号管理</el-button>
                    <!-- <el-button link type="success" size="mini" @click="test(scope.row)">续期</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
      </div> 
      <div>
        <el-dialog title="添加账号（功能包含自动偷福地，10点领玉、树广告、青蛙等广告激励自动领取，账号添加成功后请联系作者开启功能,作者微信：llnunu）" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
          <el-form :model="form">
            <el-form-item label="账号" :label-width="formLabelWidth">
              <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="formLabelWidth">
              <el-input v-model="form.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="区服（xx山xx服）" :label-width="formLabelWidth">
              <el-input v-model="form.serverName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="福地规则" :label-width="formLabelWidth">
              <div v-for="item in form.rules">
                <el-checkbox v-model="item.isCheck"></el-checkbox>
                <el-select v-model="item.minItemLv" placeholder="请选择">
                  <el-option key="1" :label="1" :value="1"/>
                  <el-option key="2" :label="2" :value="2"/>
                  <el-option key="3" :label="3" :value="3"/>
                  <el-option key="4" :label="4" :value="4"/>
                  <el-option key="5" :label="5" :value="5"/>
                </el-select>
                {{ item.description }}
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="编辑账号（功能包含自动偷福地，10点领玉、树广告、青蛙等广告激励自动领取）" :visible.sync="dialogFormVisibleBJ" :close-on-click-modal="false">
          <el-form :model="formBJ">
            <el-form-item label="是否启用" :label-width="formLabelWidth">
              <el-checkbox v-model="formBJ.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item label="账号" :label-width="formLabelWidth">
              <el-input v-model="formBJ.username" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="formLabelWidth">
              <el-input v-model="formBJ.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="区服（xx山xx服）" :label-width="formLabelWidth">
              <el-input v-model="formBJ.serverName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="角色名" :label-width="formLabelWidth">
              <el-input v-model="formBJ.nickName" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="福地规则" :label-width="formLabelWidth">
              <div v-for="item in formBJ.rules">
                <el-checkbox v-model="item.isCheck"></el-checkbox>
                <el-select v-model="item.minItemLv" placeholder="请选择">
                  <el-option key="1" :label="1" :value="1"/>
                  <el-option key="2" :label="2" :value="2"/>
                  <el-option key="3" :label="3" :value="3"/>
                  <el-option key="4" :label="4" :value="4"/>
                  <el-option key="5" :label="5" :value="5"/>
                </el-select>
                {{ item.description }}
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisibleBJ = false">取 消</el-button>
            <el-button type="primary" @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  
</template>

<script>
import axios from 'axios'
// import jsonFile from '@/assets/json/account.json';
// import qufu from '@/assets/json/qufu.json';

export default {
  name: "diy",
  data() {
    return {
      searchValue: {
        loginId: '',
      },
      form: {
          enabled: true,
          username: '',
          password: '',
          serverName: '',
          rules: [
              { "ItemId": 100004, "minItemLv": 3, "isCheck": true, "description": "仙桃" },
              { "ItemId": 100025, "minItemLv": 4, "isCheck": true, "description": "净瓶水" },
              { "ItemId": 100000, "minItemLv": 5, "isCheck": false, "description": "仙玉" },
              { "ItemId": 100003, "minItemLv": 5, "isCheck": false, "description": "灵石" },
              { "ItemId": 100029, "minItemLv": 5, "isCheck": false, "description": "琉璃珠" },
              { "ItemId": 100044, "minItemLv": 5, "isCheck": false, "description": "天衍令" },
              { "ItemId": 100047, "minItemLv": 5, "isCheck": false, "description": "昆仑铁" }
          ],
        },
        formBJ: {
        },
      formLabelWidth: '120px',
      dialogFormVisible: false,
      dialogFormVisibleBJ: false,
      items: [],
      serverInfo: [],
      data:[],

      options: [],

      question: '',
      reply: '',
      loading: false,
      xloading: false,
      params: {
          "prompt": "",
          "userId": "#/chat/1682039457204",
          "network": true,
          "system": "",
          "withoutContext": false
      }
    }
  },
  
  beforeCreate() {
    document.querySelector('body').classList.add("overall");
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove("overall");
  },

  mounted() {

    this.ZhInfo();
    // this.quInfo();
    
  },

  methods: {
    
    daysBetweenDates(dateString1, dateString2) {
      // 将日期字符串转换为Date对象
      var date1 = new Date(dateString1);
      var date2 = new Date(dateString2);

      // 检查日期是否有效
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
          throw new Error('Invalid date');
      }

      // 计算两个日期之间的时间差（以毫秒为单位）
      var diffInMs = Math.abs(date2 - date1);

      // 转换为天数
      var diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return diffInDays;
    },


    ZhInfo() {
      this.getRequest("xundao/AllZh").then(resp => {
        this.loading = false;
        if (resp) {
          this.items = resp.obj
        }
      });
    },

    quInfo() {
      this.getRequest("xundao/AllQf").then(resp => {
        if (resp) {
          this.serverInfo = resp.obj
        }
      });
    },

    ZhOne() {
      this.getRequest("xundao/zh?id=" + this.searchValue.loginId).then(resp => {
        this.loading = false;
        if (resp) {
          this.items = resp.obj
        }
      });
    },



    shengyutianshu(row, column) {
      var property = row[column.property];
      if("9999-12-31" == property) {
        return "无限期";
      } else {
        var now = new Date();
        var year = now.getFullYear();
        var month = ('0' + (now.getMonth() + 1)).slice(-2); // getMonth() 是 0-based 的
        var day = ('0' + now.getDate()).slice(-2);
        let m = this.daysBetweenDates(property, year + '-' + month + '-' + day)

        var date1 = new Date(property);
        var date2 = new Date();

        if(date1 > date2) {
          return 30 + m;
        } else {
          let n = 30 - m;
          if(n < 0) {
            return 0;
          }
          return 30 - m;
        }
      }
    },

    addZh() {
      this.form = {
          enabled: true,
          username: '',
          password: '',
          serverName: '',
          rules: [
              { "ItemId": 100004, "minItemLv": 3, "isCheck": true, "description": "仙桃" },
              { "ItemId": 100025, "minItemLv": 4, "isCheck": true, "description": "净瓶水" },
              { "ItemId": 100000, "minItemLv": 5, "isCheck": false, "description": "仙玉" },
              { "ItemId": 100003, "minItemLv": 5, "isCheck": false, "description": "灵石" },
              { "ItemId": 100029, "minItemLv": 5, "isCheck": false, "description": "琉璃珠" },
              { "ItemId": 100044, "minItemLv": 5, "isCheck": false, "description": "天衍令" },
              { "ItemId": 100047, "minItemLv": 5, "isCheck": false, "description": "昆仑铁" }
          ],
        }
      this.dialogFormVisible = true
    },

    zhBJ(row) {
      this.formBJ = row;
      this.dialogFormVisibleBJ = true
    },

    submitAdd() {
      this.postRequest("xundao/addGR", this.form).then(resp => {
        if (resp && resp.status == "200") {
          this.dialogFormVisible = false
        }
      });
    },

    submitEdit() {
      this.postRequest("xundao/editGR", this.formBJ).then(resp => {
        if (resp && resp.status == "200") {
          this.dialogFormVisibleBJ = false
        }
      });
    },

    test(state) {

      this.getRequest("xundao/AllQf").then(resp => {
        this.loading = false;
        if (resp) {
          console.log(resp.obj)
        }
      });

    },
    
  }
}
</script>

<style>
.loginContainer {
  background-clip: padding-box;
  width: 90%;
  height: 100%;
  margin-top: 120px;
  margin-left: 100px;
}

.overall {
  position: absolute;
  content: ' ';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  background-image: url(../assets/xundao.jpg);
  background-size: cover;
}
</style>
